import React, { Component } from "react";
import "./MemberProfile.scss";
import { selectIcon, SVG } from "../../components/UI/selector";
import {
  FieldGroup,
  FieldControl,
  FormBuilder,
  Validators,
  FormControl,
} from "react-reactive-form";
import {
  FormGroups,
  FormGroupRow,
} from "../../components/ReusableComponents/FormGroups/FormGroups";
import { TextInput, CustomDate } from "../../components/UI/FormInput/FormInput";
import { pattern } from "../../services/subscriberService";
import MemberProfileUpload from "../../components/ReusableComponents/MemberProfileUpload/MemberProfileUpload";
import {
  CheckImageType,
  CheckValue,
  formatBytes,
} from "../../services/CommonFunction";
import {
  ErrorListUI,
  ErrorUI,
  OpenChangePasswordModal,
  OpenDeleteAccountModal,
} from "../../components/UI/Modals/Modals";
import Button from "../../components/ReusableComponents/Button/Button";
import { profileActions } from "../../store";
import { connect } from "react-redux";
import {
  checkCm_Feet,
  checkFT_value,
  checkKg_Pound,
  height_weight_subscriber,
  imageForm,
  imgUpload,
  touched,
} from "../../services/CommonFormFunction";
import { getAppNameFromURL } from "../../services/Constants";
import { differenceInYears, formatISO, parseISO } from "date-fns";
import { updateProfile } from "../../services/CallApi";
import moment from "moment";

class MemberProfile extends Component {
  constructor(props) {
    super(props);
    const { profile } = props;

    const weight_value = profile.weight_value / 1000;
    this.profileForm = FormBuilder.group({
      profile_pic: FormBuilder.group(
        imageForm({ ...profile, keyValue: "thumb" })
      ),
      first_name: new FormControl(profile.first_name, {
        validators: [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
        ],
      }),
      last_name: new FormControl(profile.last_name, {
        validators: [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(25),
        ],
      }),
      email: new FormControl(
        { value: profile.email, disabled: true },
        {
          validators: [
            Validators.required,
            Validators.pattern(pattern.username),
          ],
        }
      ),
      dob: new FormControl(profile.dob, { validators: Validators.required }),
      height_unit: new FormControl(profile.height_unit),
      height_value: new FormControl(
        checkCm_Feet(
          profile.height_unit,
          profile.height_value,
          profile.height_unit === "CMs"
        ),
        {
          validators: Validators.required,
        }
      ),
      weight_value: new FormControl(
        checkKg_Pound(
          profile.weight_unit,
          weight_value,
          profile.weight_unit === "Kg"
        ),
        {
          validators: Validators.required,
        }
      ),
      weight_unit: new FormControl(profile.weight_unit),
      gender: new FormControl(profile.gender),
    });
  }

  appName = getAppNameFromURL();

  componentDidMount() {
    height_weight_subscriber("subscribe", this.profileForm);
  }

  componentWillUnmount() {
    height_weight_subscriber("unsubscribe", this.profileForm);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.profileForm.valid) {
      const formData = new FormData();
      const formValue = this.profileForm.getRawValue();
      const { updateProfileData } = this.props;
      //formData.append("email", formValue.email)
      formData.append("first_name", formValue.first_name);
      formData.append("last_name", formValue.last_name);
      formData.append("height_unit", formValue.height_unit);
      formData.append(
        "height_value",
        checkCm_Feet(
          "CMs",
          formValue.height_value,
          formValue.height_unit === "CMs"
        )
      );
      formData.append(
        "weight_value",
        checkKg_Pound(
          "Kg",
          formValue.weight_value,
          formValue.weight_unit === "Kg"
        ) * 1000
      );
      formData.append("weight_unit", formValue.weight_unit);
      formData.append("dob", new Date(formValue.dob).toISOString());
      formData.append("gender", formValue.gender);
      if (formValue.profile_pic.upload) {
        formData.append("profile_pic", formValue.profile_pic.value);
      }

      updateProfile(formData).then((res) => {
        if (res.status) {
          updateProfileData(res.data);
          touched("first_name", this.profileForm);
          ErrorUI("Your profile was updated successfully!");
        } else {
          ErrorUI(res.list, () => this.handleSubmit(e));
        }
      });
    } else {
      let text = [];
      Object.keys(this.profileForm.controls).forEach((el) => {
        const control = this.profileForm.get(el);
        if (control.invalid) {
          text.push(control.meta.label);
          control.markAsTouched({ emitEvent: true });
          this.profileForm.markAsTouched({ emitEvent: true });
        }
      });
      ErrorListUI("Please fill the following fields to continue", null, {
        arymsgs: text,
      });
    }
  };

  dateChangeHandler = (date) => {
    this.profileForm.patchValue({
      dob: date,
    });
    touched("dob", this.profileForm);
  };

  fileUpload = React.createRef < HTMLInputElement > null;

  cancelDeletionRequest = () => {
    updateProfile({ cancel_delete_request: true }).then((res) => {
      if (res.status) {
        ErrorUI("Request Cancelled");
      } else {
        ErrorUI(res.list, () => this.cancelDeletionRequest());
      }
    });
  };

  render() {
    const { profile } = this.props;

    const gymName =
      this.appName.charAt(0).toUpperCase() + this.appName.slice(1);

    const mhr =
      208 - 0.7 * differenceInYears(new Date(), parseISO(profile.dob));

    return (
      <div className="MemberProfile">
        <div className="MemberProfileLeftConntainerParent">
          <div className="MemberProfileLeftContainer">
            {/* <div className="MemberProfileBannerDiv">
              <img src={selectIcon("exercise1")} />
              <div className="ProfileIconCircle">
                <SVG src={selectIcon("editBannerIcon")} />
              </div>
            </div> */}
            {/* <MemberProfileUpload /> */}
            <div className="MemberProfileFormDiv">
              <FieldGroup
                control={this.profileForm}
                render={({ get, invalid }) => (
                  <form onSubmit={this.handleSubmit}>
                    <FieldGroup
                      control={get("profile_pic")}
                      meta={{ label: "Profile Picture" }}
                      render={({ get, touched }) => (
                        <MemberProfileUpload
                          image={get("image").value}
                          name={null}
                          showError={
                            touched && get("value").hasError("required")
                          }
                        >
                          <input
                            type="file"
                            onChange={(e) =>
                              imgUpload(e, this.profileForm, "profile_pic")
                            }
                            accept="image/heic,image/*"
                          />
                        </MemberProfileUpload>
                      )}
                    />
                    <p className="fullname">{profile.name}</p>
                    <FormGroupRow>
                      <FormGroups>
                        <FieldControl
                          name="first_name"
                          render={TextInput}
                          meta={{
                            label: "First Name",
                            showLabel: true,
                            type: "text",
                            placeholder: "First Name",
                            placeHolderIcon: "dropdownProfile",
                            minLength: "2",
                            maxLength: "25",
                            valid: true,
                            showError: true,
                          }}
                        />
                      </FormGroups>
                      <FormGroups>
                        <FieldControl
                          name="last_name"
                          render={TextInput}
                          meta={{
                            label: "Last Name",
                            showLabel: true,
                            type: "text",
                            placeholder: "Last Name",
                            placeHolderIcon: "dropdownProfile",
                            minLength: "2",
                            maxLength: "25",
                            valid: true,
                            showError: true,
                          }}
                        />
                      </FormGroups>
                    </FormGroupRow>
                    <FormGroupRow>
                      <FormGroups>
                        <FieldControl
                          name="email"
                          render={TextInput}
                          meta={{
                            label: "Email",
                            showLabel: true,
                            type: "text",
                            placeholder: "Email",
                            placeHolderIcon: "emailInput",
                            valid: true,
                            showError: true,
                          }}
                        />
                      </FormGroups>
                      <FormGroups>
                        <FieldControl
                          name="dob"
                          meta={{ label: "DOB", showLabel: true }}
                          render={({
                            // handler,
                            touched,
                            hasError,
                            valid,
                            // validator,
                            // errors,
                            ...props
                          }) => {
                            return (
                              <CustomDate
                                label="Date Of Birth"
                                date={parseISO(get("dob").value || new Date())}
                                maxDate={
                                  new Date(moment().subtract(16, "years"))
                                }
                                handler={(el, status) =>
                                  this.dateChangeHandler(formatISO(el))
                                }
                                showError={touched && hasError("required")}
                                valid={valid}
                              />
                            );
                          }}
                        />
                      </FormGroups>
                    </FormGroupRow>
                    <div className="InputButtonRow">
                      <div className="InputButtonContainer">
                        <div className="InputContainer">
                          <FormGroups>
                            <FieldControl
                              name="height_value"
                              render={TextInput}
                              meta={{
                                label: "Height",
                                showLabel: true,
                                type: "number",
                                maxLength: "5",
                                placeholder: "Height",
                                placeHolderIcon: "",
                                valid: true,
                                showError: false,
                              }}
                            />
                          </FormGroups>
                          {/* <FormGroups>
                            <FieldControl
                              name="height_unit"
                              render={CustomSelectBox}
                              meta={{
                                formKey: "height_unit",
                                optionList: height,
                                label: "",
                                placeholder: "",
                                validation: true,
                              }}
                            />
                          </FormGroups> */}
                        </div>
                        <UiButton
                          get={get}
                          text={["Feet", "CMs"]}
                          keyName={"height_unit"}
                          value={["Feet", "CMs"]}
                          form={this.profileForm}
                        />
                      </div>
                      <div className="InputButtonContainer">
                        <div className="InputContainer">
                          <FormGroups>
                            <FieldControl
                              name="weight_value"
                              render={TextInput}
                              meta={{
                                label: "Weight",
                                showLabel: true,
                                type: "text",
                                placeholder: "Weight",
                                placeHolderIcon: "",
                                valid: true,
                                showError: true,
                              }}
                            />
                          </FormGroups>
                        </div>
                        <UiButton
                          get={get}
                          text={["Lbs", "Kgs"]}
                          keyName={"weight_unit"}
                          value={["Pounds", "Kg"]}
                          form={this.profileForm}
                        />
                      </div>
                    </div>
                    <p className="GenderText">Gender</p>
                    <div className="InputButtonRow">
                      <div className="InputButtonContainer">
                        <Button
                          className="InputButton"
                          text="Male"
                          icon="maleIcon"
                          disabled={get("gender").value !== "MALE"}
                          onClick={() => {
                            this.profileForm.patchValue({
                              gender: "MALE",
                            });
                            touched("gender", this.profileForm);
                          }}
                        />
                        <Button
                          className="InputButton"
                          text="Female"
                          icon="femaleIcon"
                          disabled={get("gender").value !== "FEMALE"}
                          onClick={() => {
                            this.profileForm.patchValue({
                              gender: "FEMALE",
                            });
                            touched("gender", this.profileForm);
                          }}
                        />
                        <Button
                          className="InputButton"
                          text="Others"
                          icon="otherGender"
                          disabled={get("gender").value !== "OTHER"}
                          onClick={() => {
                            this.profileForm.patchValue({
                              gender: "OTHER",
                            });
                            touched("gender", this.profileForm);
                          }}
                        />
                      </div>
                      <div className="InputButtonContainer justifySB">
                        <Button
                          className="InputButton"
                          type="submit"
                          text="SAVE"
                        />
                        <p
                          className="ChangePasswordText"
                          onClick={() => OpenChangePasswordModal()}
                        >
                          Change Password?
                        </p>
                      </div>
                    </div>
                  </form>
                )}
              />
            </div>
            <div className="FooterDeleteContainer">
              <div
                onClick={
                  profile.deletion_requested_at
                    ? this.cancelDeletionRequest
                    : OpenDeleteAccountModal
                }
              >
                <div className="FooterDeleteIconContainer">
                  <SVG src={selectIcon("deleteAccount")} />
                </div>
                <p>
                  {profile.deletion_requested_at
                    ? "Cancel Deletion Request"
                    : "Delete Account"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="MemberProfileRightContainer">
          <p className="PersonalRecord">Personal record</p>
          <div className="CalculationDetail">
            <SVG src={selectIcon("heartIcon")} className="HeartRateIcon1" />
            <div className="CalculationSecondaryContainer">
              <p className="CalculationDetailText">
                {gymName} calculates your Maximum heart Rate based on the
                formula 208 - (0.7 * your age). There are many formulas out
                there, none of which are infallible, but we decide to pick one
                and stick with it because we use heart rate data and calories
                burned for competitive rankings in {gymName}.
              </p>
            </div>
          </div>
          <hr className="MemberProfileLineBreaker" />
          <div className="CalculationDetail">
            <SVG className="HeartRateIcon" src={selectIcon("HeartRateIcon")} />
            <div className="CalculationSecondaryContainer">
              <p className="CalculationDetailText">Your Max Heart Rate : </p>
              <div className="CalculationHeartRateStats">
                <p>{Math.round(mhr)} BPM</p>
              </div>
            </div>
          </div>
          <hr className="MemberProfileLineBreaker" />
          <div className="CalculationDetail">
            <SVG className="HeartRateIcon" src={selectIcon("watchHeartRate")} />
            <div className="CalculationSecondaryContainer">
              <p className="CalculationDetailText">
                Your Heart Rate Bands in {gymName}
              </p>
            </div>
          </div>
          <div className="calculationHeartRateZones">
            <div className="heartBar1 heartRed"></div>
            <div className="heartBar2 heartRed"></div>
            <div className="heartBarIconDiv">
              <SVG src={selectIcon("heartIcon")} />
            </div>
            <p className="heartBarText">
              Red - Max Effort: {Math.round(0.9 * mhr)} BPM or 90% MHR
            </p>
          </div>
          <div className="calculationHeartRateZones">
            <div className="heartBar1 heartOrange"></div>
            <div className="heartBar2 heartOrange"></div>
            <div className="heartBarIconDiv">
              <SVG src={selectIcon("heartIcon")} />
            </div>
            <p className="heartBarText">
              Orange - Hardcore: {Math.round(0.8 * mhr)} BPM or 80% MHR
            </p>
          </div>
          <div className="calculationHeartRateZones">
            <div className="heartBar1 heartYellow"></div>
            <div className="heartBar2 heartYellow"></div>
            <div className="heartBarIconDiv">
              <SVG src={selectIcon("heartIcon")} />
            </div>
            <p className="heartBarText">
              Yellow - Endurance: {Math.round(0.7 * mhr)} BPM or 70% MHR
            </p>
          </div>
          <div className="calculationHeartRateZones">
            <div className="heartBar1 heartGreen"></div>
            <div className="heartBar2 heartGreen"></div>
            <div className="heartBarIconDiv">
              <SVG src={selectIcon("heartIcon")} />
            </div>
            <p className="heartBarText">
              Green - Fat Burning: {Math.round(0.6 * mhr)} BPM or 60% MHR
            </p>
          </div>
          <div className="calculationHeartRateZones">
            <div className="heartBar1 heartBlue"></div>
            <div className="heartBar2 heartBlue"></div>
            <div className="heartBarIconDiv">
              <SVG src={selectIcon("heartIcon")} />
            </div>
            <p className="heartBarText">
              Blue - Warm UP: {Math.round(0.5 * mhr)} BPM or 50% MHR
            </p>
          </div>
          <p className="calcFooterText">
            in general, using heart rate data to calculate calories burned
            during exercise is much more accurate than the numbers you see on
            gym cardio stations.
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: { ...state.profile.profileData },
});

const mapDispatchToProps = (dispatch) => ({
  updateProfileData: (data) => dispatch(profileActions.updateProfileData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberProfile);

const UiButton = ({ get, keyName, value, text, form }) => (
  <React.Fragment>
    {[0, 1].map((el, index) => (
      <Button
        key={index}
        className="InputButton triggerButton"
        text={text[el]}
        disabled={get(keyName).value !== value[el]}
        onClick={() => {
          if (get(keyName).value !== value[el]) {
            form.patchValue({
              [keyName]: value[el],
            });
          }
        }}
      />
    ))}
  </React.Fragment>
);
